import React from "react";
import { Box, IconButton, Typography, makeStyles } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

const useStyles = makeStyles({
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 16px",
    backgroundColor: "#1976d2",
    color: "#fff",
    cursor: "pointer",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  title: {
    fontWeight: 600,
    color: "#fff",
  },
  icon: {
    color: "#fff",
  },
});

export default function ChatHeader({ collapsed, onToggle, title }) {
  const classes = useStyles();
  return (
    <Box className={classes.header} onClick={onToggle}>
      <Typography className={classes.title}>{title}</Typography>
      <IconButton size="small" className={classes.icon} onClick={onToggle}>
        {collapsed ? (
          <KeyboardArrowUpIcon style={{ color: "#fff" }} />
        ) : (
          <KeyboardArrowDownIcon style={{ color: "#fff" }} />
        )}
      </IconButton>
    </Box>
  );
}
